export const randomSort = <TItem>(array: TItem[]) => {
  return array.sort(() => Math.random() - 0.5);
};
